<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Quejas"
          directory="Registro"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            Añadir
          </button>
        </div>
      </div>
    </div>
    <app-table :id="tableId" :options="options" @action="getListAction" />

    <register-complaint-modal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
      modalTitle="Añadir Queja"
      editModalTitle="Editar Queja"
      :accreditation-area-list="accreditationAreaList"
      :accreditation-activity-list="accreditationActivityList"
    />

    <register-complaint-doc-modal
      v-if="isAddEditModalActiveDoc"
      :table-id="tableId"
      :selected-url="selectedUrlDoc"
      @close-modal="closeAddEditModalDoc"
    />

    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      modal-id="modal-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este registro?"
    />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../../apiUrl";
import { axiosGet } from "@/app/helpers/AxiosHelper";
import { TableHelpers } from "./TableHelpers";

export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  data() {
    return {
      deleteLoader: false,
      isAddEditModalActive: false,
      isAddEditModalActiveDoc: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      selectedUrlDoc: "",
      tableId: "register-complaint-table",
      rowData: {},
      options: {
        name: "register-complaint-table",
        url: `/complaints/register/index`,
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
          },
          {
            title: this.$t("Documento"),
            icon: "file",
            type: "none",
          },
          {
            title: this.$t("Auditoría"),
            icon: "eye",
            type: "none",
          },
          {
            title: this.$t("Nueva Queja"),
            icon: "info",
            type: "none",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "app-confirmation-modal",
            modalId: "modal-delete",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  computed: {
    accreditationAreaList() {
      return [
        { id: "", value: "Selecciona una opción" },
        ...this.$store.state.accreditation.accAppOptions.accreditationAreas,
      ];
    },
    accreditationActivityList() {
      return [
        { id: "", value: "Selecciona una opción" },
        ...this.$store.state.accreditation.accAppOptions
          .accreditationActivities,
      ];
    },
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.searchAndSelectFilterOptions();
    this.data();
  },
  methods: {
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    openAddEditModalDoc() {
      this.isAddEditModalActiveDoc = true;
    },
    closeAddEditModalDoc() {
      this.isAddEditModalActiveDoc = false;
    },
    closeAddEditModal() {
      $("#modal-add-edit").modal("hide");
      this.isAddEditModalActive = false;
      this.searchAndSelectFilterOptions();
      this.reSetData();
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      // window.location = `${actions.EXECUTIVE_DIRECTOR}/issuanceResolution/612/view/${this.rowData.id}`;
      if (actionObj.title == this.$t("delete")) {
        // this.openDeleteModal();
        let selectedE = `complaints/register/${rowData.id}`;
        axiosGet(selectedE).then((response) => {
          if (response.data.status_complaint.code == "700") {
            this.openDeleteModal();
          } else {
            this.$toastr.e("La queja está en proceso");
          }
        });
      } else if (actionObj.title == this.$t("edit")) {
        let selectedD = `complaints/register/${rowData.id}`;
        axiosGet(selectedD).then((response) => {
          if (response.data.status_complaint.code == "700") {
            this.selectedUrl = `complaints/register/${rowData.id}`;
            this.openAddEditModal();
          } else {
            this.$toastr.e("La queja está en proceso");
          }
        });
      } else if (actionObj.title == this.$t("Documento")) {
        let selectedC = `complaints/register/${rowData.id}`;
        axiosGet(selectedC).then((response) => {
          if (response.data.status_complaint.code == "700") {
            window.location = `/complaints/register/view/${this.rowData.id}`;
          } else {
            this.$toastr.e("La queja está en proceso");
          }
        });
      } else if (actionObj.title == this.$t("Auditoría")) {
        this.selectedUrlDoc = `complaints/register/${rowData.id}`;
        this.openAddEditModalDoc();
      } else if (actionObj.title == this.$t("Nueva Queja")) {
        let selectedA = `complaints/register/${rowData.id}`;
        axiosGet(selectedA).then((response) => {
          if (response.data.status_complaint.code == "706") {
            window.location = `/complaints/register/viewAboutComplaint/${this.rowData.id}`;
          } else if (response.data.status_complaint.code == "707") {
            this.$toastr.e("La nueva queja está en proceso");
          } else {
            this.$toastr.e(
              "No puede realizar este operación por que la queja esta en curso"
            );
          }
        });
      }
    },
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      let url = `complaints/register/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#modal-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(this.$t("deleted_success"));
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
          this.searchAndSelectFilterOptions();
        });
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },

    data() {
      this.$store.dispatch("getAccAppOptions");
    },
    searchAndSelectFilterOptions() {
      let url = `accreditations/applications/options`;
      axiosGet(url).then((response) => {
        let activity = this.options.filters.find(
          (element) => element.title === "Actividad"
        );
        activity.option = response.data.accreditationActivities.map(
          (activity) => {
            return {
              id: activity.id,
              value: activity.value,
            };
          }
        );
      });

      // let reasonListUrl = `complaints/register/reasonComplaintsList/${1}`;
      // axiosGet(reasonListUrl).then((response) => {
      //   this.reasonList = response.data;
      // });
    },
  },
};
</script>
